import { render } from "./SelectGroups.vue?vue&type=template&id=ad81cf88"
import script from "./SelectGroups.vue?vue&type=script&lang=js"
export * from "./SelectGroups.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__